import React from 'react';
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";
import totalCollected from '../../assets/totalCollected.svg'
import inProgress from '../../assets/inProgress.svg'
import firstGraph from '../../assets/firstGraph.svg'
import secondGraph from '../../assets/secondGraph.svg'
import recentActivityIcon from '../../assets/recentActivityIcon.svg'
import typeOfVariationinShade from '../../assets/typeOfVariationinShade.svg'
import Navbar from '../../components/NavBar/navBar'
import bacteriaIcon from '../../assets/bacteriaIcon.svg'
import Samples from '../../assets/Samples.svg';
import MostCommonCT from '../../assets/MostCommonCT.svg'
import TypeOfVariation from '../../assets/TypeOfVariation.svg'
import moment from 'moment';
import { Input, Col, Row } from 'reactstrap';
import { ComposedChart, LineChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, Line, ResponsiveContainer, LabelList } from "recharts";
import Tour from '../../Tour';
import './dashboard.css';
import "react-datepicker/dist/react-datepicker.css";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from "../../AppInsights";
import {
    fetchSampleCount,
    fetchBuilding,
    fetchFloors,
} from '../../actions';
import CardImg from 'reactstrap/lib/CardImg';
import CardBody from 'reactstrap/lib/CardBody';
import CardText from 'reactstrap/lib/CardText';
import Card from 'reactstrap/lib/Card';
import DatePicker from 'react-datepicker';
const colors = ['#f58026', '#0f61f5', '#00d168', '#7548c7', '#f53a1b']

class Dashboard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            SamplesPeriod: "",
            CTPeriod: "",
            filterType: "complex_type",
            building: "",
            buildingId: "",
            fromDate: "",
            toDate: "",
            complex_period: "",
            seq_period: "",
            speciesStartDate: "",
            speciesMonth: "",
            speciesYear: "",
            speciesEndDate: "",
            speciesData: []
        }
    }
    columns = [
        {
            Header: 'Activity',
            accessor: 'object'
        },
        {
            Header: 'Count',
            accessor: 'count'
        },
        {
            Header: 'Date & Time',
            accessor: 'last_action_time',
            Cell: (props) => {
                let date = new Date(props.value)
                date = moment(date).format('MMM D, YYYY HH:mm')
                return <span>{date}</span>
            },
            width: 170
        },
        {
            Header: 'Added Items',
            accessor: 'added_values',
            Cell: (props) => {
                return <span>{props.value}</span>
            },
            width: 170
        },
        {
            Header: "By",
            accessor: 'user'
        }
    ]

    componentDidMount() {
        this.applyFilter()
        this.getSpeciesData()
    }

    tiltedAxisTick = (props) => {
        const { x, y, payload } = props;
        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="end"
                    fill="#666"
                    transform="rotate(-45)">
                    {payload.value}
                </text>
            </g>
        )
    }

    onSelectBuilding = (event) => {
        const { value, selectedOptions } = event.target
        this.setState({
            ...this.state,
            building: value,
            buildingId: selectedOptions[0].id,
            buildingName: selectedOptions[0].innerText,
        }, this.applyFilter)
    }

    applyFilter = () => {
        this.props.fetchSampleCount({
            filter_type: this.state.filterType,
            building_id: this.state.buildingId,
            samples_period: this.state.SamplesPeriod,
            ct_period: this.state.CTPeriod,
            complex_period: this.state.complex_period,
            seq_period: this.state.seq_period,
            species_start_date: this.state.speciesStartDate,
            species_month: this.state.speciesMonth,
            species_year: this.state.speciesYear,
        })
    }

    handleChangeSelect = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        }, this.applyFilter)
    }

    clearSampleLocations = () => this.setState({
        buildingId: "",
        building: "",
        SamplesPeriod: "",
    }, this.applyFilter)

    clear_CT_ST_Locations = () => this.setState({
        filterType: "complex_type",
        CTPeriod: ""
    }, this.applyFilter)

    customizedTooltipVerticalGraph = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="chart-tooltip">
                    <p className="label">Strain Type: {`${label}`}</p>
                    <p className="label">Count of Occurence: {`${payload[0].value}`}</p>
                </div>
            );
        }
        return null;
    };
    customizedTooltipChartGraph = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="chart-tooltip">
                    <p className="label">{`${label}`}</p>
                    <p className="label">Samples: {`${payload[0].value}`}</p>
                    <p className="label">Results: {`${payload[1].value}`}</p>
                </div>
            );
        }
        return null;
    };

    clear_dates = () => {
        this.setState({
            speciesStartDate: "",
            speciesEndDate: "",
            speciesMonth: "",
            speciesYear: "",
            CTPeriod: ""
        }, this.getSpeciesData)
    }

    onYearChange = (name, date) => {
        this.setState({
            [name]: date,
            speciesStartDate: (name === "speciesYear") ? "" : this.state.speciesStartDate,
            speciesEndDate: (name === "speciesYear") ? "" : this.state.speciesEndDate,
            speciesMonth: (name === "speciesYear") ? "" : this.state.speciesMonth,
        }, this.getSpeciesData)
    }

    onMonthChange = (name, date) => {
        this.setState({
            [name]: date,
            speciesStartDate: (name === "speciesMonth") ? "" : this.state.speciesStartDate,
            speciesEndDate: (name === "speciesMonth") ? "" : this.state.speciesEndDate,
            speciesYear: (name === "speciesMonth") ? "" : this.state.speciesYear,
        }, this.getSpeciesData)
    }

    onDateChange = (nameStart, nameEnd, date) => {
        let today = new Date(new Date().toDateString())
        let lastDate = new Date(moment(date).add(6 - moment(date).day(), 'days'))
        let firstDate = moment(date).subtract(moment(date).day(), 'days')
        let presentWeek = moment(today).subtract(moment(today).day(), 'days')
        this.setState({
            [nameStart]: new Date(presentWeek.diff(firstDate, 'days') > 0 ? firstDate : presentWeek.subtract(6 - moment(today).day(), 'days')),
            [nameEnd]: lastDate > today ? today : lastDate,
            speciesMonth: (nameStart === "speciesStartDate") ? "" : this.state.speciesMonth,
            speciesYear: (nameStart === "speciesStartDate") ? "" : this.state.speciesYear,
        },
            () => { return nameStart === "speciesStartDate" ? this.getSpeciesData() : null })
    }

    getWeek = date => {
        let dates = []
        if (date !== "")
            for (let i = 0; i < 7; i++) {
                let currDate = new Date(moment(date).add(i, 'days'))
                if (currDate > new Date())
                    break
                dates.push(currDate)
            }
        return dates
    }

    getSpeciesData = () => {
        let species = ["Gadus morhua", "Pollachius virens", "Salmo salar", "Abramis brama",
            "Cyprinus carpio", "Theragra chalcogramma", "Gadus macrocephalus", "Melanogrammus aeglefinus",
            "Pangasianodon hypophthalmus", "Oncorhynchus gorbuscha", "Oncorhynchus kisutch", "Oncorhynchus mykiss",
            "Oncorhynchus nerka", "Ameiurus melas", "Cyprinus carpio"].sort(() => Math.random() - Math.random()).slice(0, 5)
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        const Weeks = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"]

        let startDate;
        if (!this.state.speciesStartDate) {
            let today = new Date(new Date().toDateString())
            let presentWeek = moment(today).subtract(moment(today).day(), 'days')
            startDate = presentWeek.subtract(6 - moment(today).day(), 'days')
        }
        else
            startDate = this.state.speciesStartDate
        let days = [...Array(7).keys()].map(i => moment(startDate).add('days', i).format("DD/MM/YYYY"))
        let type = (this.state.CTPeriod === "Monthly") ? Weeks : (this.state.CTPeriod === "Yearly") ? months : days
        let divider = (this.state.CTPeriod === "Monthly") ? 2 : (this.state.CTPeriod === "Yearly") ? 4 : 8
        let intialValues = [10, 20, 30, 40, 50, 60, 70, 80, 90].sort(() => Math.random() - Math.random()).slice(0, 5)
        let speciesData = [...type.map((types, indexT) => {
            let data = {}
            data["name"] = types
            let values = []
            species.forEach((org, indexS) => {
                data[org] = Math.min(Math.max(intialValues[indexS] + (Math.floor((indexT + indexS) / divider) % 2 ? 5 : -5), 0), 100)
                values.push(data[org])
            })
            intialValues = values
            return data
        })]
        this.setState({ speciesData: speciesData })
    }

    render() {
        const { recent_activity } = this.props.dashboardData
        return (
            <>
                <div className="page-layout">
                    <Navbar />
                    <div className="dashboard-overview" data-tut="reactour__dashboardPage">
                        <Row className="stats" >
                            <Col className="stats-heading">
                                <Card className="card-elements h-100" data-tut="reactour__samples">
                                    <CardBody className="body-text">
                                        <Row className="nowrap-item">
                                            <Col>
                                                <Row className="nowrap-item left-margin">
                                                    <CardImg className='card-icons-species' src={Samples} alt="" />
                                                    <Col className="card-header">Sample Collected</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <hr className='border-line' />
                                        <Row className="nowrap-item">
                                            <Col className="left-padding">
                                                <Row className="nowrap-item">
                                                    <CardImg src={totalCollected} alt='' left className="card-image" />
                                                    <Col>
                                                        <CardText >{this.props.dashboardData.totalSamples}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <CardText className="footer-text">Total Collected</CardText>
                                                </Row>
                                            </Col>
                                            <Col className="left-padding">
                                                <Row className="nowrap-item">
                                                    <CardImg src={inProgress} alt='' left className="card-image" />
                                                    <Col>
                                                        <CardText className="total-samples">{this.props.dashboardData.total_waiting_samples}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <CardText className="footer-text" >In Progress</CardText>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col className="stats-heading">
                                <Card className="card-elements h-100" data-tut="reactour__ctcard">
                                    <CardBody className="body-text">
                                        <Row className="nowrap-item">
                                            <Col>
                                                <Row className="nowrap-item left-margin">
                                                    <CardImg className='card-icons-species' src={MostCommonCT} alt="" />
                                                    <Col className="card-header">Most Common CT Type</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <hr className='border-line' />
                                        <Row className="nowrap-item">
                                            <Col className="left-padding">
                                                <Row className="nowrap-item">
                                                    <CardImg src={bacteriaIcon} alt='' left className="card-image" />
                                                    <Col>
                                                        <CardText >CT{this.props.dashboardData.salmonella_CT}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <CardText className="footer-text-salmonella">Salmonella</CardText>
                                                </Row>
                                            </Col>
                                            <Col className="left-padding">
                                                <Row>
                                                    <Col>
                                                        <CardText className="total-samples">CT{this.props.dashboardData.listeria_CT}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <CardText className="footer-text">Listeria</CardText>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col className="stats-heading">
                                <Card className="card-elements h-100" data-tut="reactour__stcard" >
                                    <CardBody className="body-text">
                                        <Row className="nowrap-item">
                                            <Col>
                                                <Row className="nowrap-item left-margin" >
                                                    <CardImg className='card-icons-species' src={MostCommonCT} alt="" />
                                                    <Col className="card-header">Most Common ST Type</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <hr className='border-line' />
                                        <Row className="nowrap-item">
                                            <Col className="left-padding">
                                                <Row className="nowrap-item">
                                                    <CardImg src={bacteriaIcon} alt='' left className="card-image" />
                                                    <Col>
                                                        <CardText >ST{this.props.dashboardData.salmonella_ST}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <CardText className="footer-text-salmonella">Salmonella</CardText>
                                                </Row>
                                            </Col>
                                            <Col className="left-padding">
                                                <Row>
                                                    <Col>
                                                        <CardText className="total-samples">ST{this.props.dashboardData.listeria_ST}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <CardText className="footer-text">Listeria</CardText>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col className="stats-heading">
                                <Card className="card-elements h-100" data-tut="reactour__results">
                                    <CardBody className="body-text variations-card">
                                        <Row className="nowrap-item last-card-padding">
                                            <CardImg className='card-icons-species' src={TypeOfVariation} alt="" />
                                            <Col className="card-header">Type of Variation & Analysis</Col>
                                        </Row>
                                        <hr className='border-line variation-card-border' style={{ marginBottom: '0.3rem' }} />
                                        <Row className="dashboard-last-card-row">
                                            <Col className="dashboard-last-card-column" >
                                                <Row className="nowrap-item"><CardImg src={typeOfVariationinShade} alt='' left className="card-image" />
                                                    <Col>
                                                        <CardText >{this.props.dashboardData.total_cgMLST_samples}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <CardText className="footer-text" style={{ paddingTop: '0' }}>cgMLST</CardText>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <pre className='last-card-sufix1'>{this.props.dashboardData.waiting_cgMLST_samples}</pre>
                                                    <Col className='last-card-sufix'>Inprogress</Col>
                                                </Row>
                                            </Col>
                                            <Col className="padding-left-sm">
                                                <Row>
                                                    <Col>
                                                        <CardText>{this.props.dashboardData.total_SNP_samples}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <CardText className="footer-text">SNP</CardText>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <pre className='last-card-sufix1'>{this.props.dashboardData.waiting_SNP_samples}</pre>
                                                    <Col className='last-card-sufix'>Inprogress</Col>
                                                </Row>
                                            </Col>
                                            <Col className="padding-left-sm">
                                                <Row>
                                                    <Col>
                                                        <CardText>{this.props.dashboardData.total_microbiome_samples}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <CardText className="footer-text">Microbiome</CardText>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <pre className='last-card-sufix1'>{this.props.dashboardData.waiting_microbiome_samples}</pre>
                                                    <Col className='last-card-sufix'>Inprogress</Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row>
                                                    <Col>
                                                        <CardText>{this.props.dashboardData.total_Other_samples}</CardText>
                                                    </Col>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <CardText className="footer-text">Other</CardText>
                                                </Row>
                                                <Row className="dashboard-last-card-row">
                                                    <pre className='last-card-sufix1'>{this.props.dashboardData.waiting_Other_samples}</pre>
                                                    <Col className='last-card-sufix'>Inprogress</Col>
                                                </Row>
                                            </Col>
                                            <Col className='result-card'>
                                                <Row className="nowrap-item">
                                                    <Col>
                                                        <Row>
                                                            <CardText className='result-card-positive'>{this.props.dashboardData.positive_result}</CardText></Row><Row><CardText className='result-card-positive'>Po</CardText>
                                                        </Row>
                                                    </Col>
                                                    <Col>
                                                        <Row>
                                                            <CardText className='result-card-negative'>{this.props.dashboardData.negative_result}</CardText>
                                                        </Row>
                                                        <Row>
                                                            <CardText className='result-card-negative'>Ne</CardText>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {window.innerWidth > 650 ?
                            <Row className={window.innerWidth > 1450 ? "graph-species" : "graph-small-species"}>
                                <Col className={window.innerWidth > 1450 ? "bargraph-species" : "bargraph-small-species"} style={window.innerWidth > 1450 ? { marginRight: '0.3%' } : { marginRight: '0%' }} data-tut="reactour__graphtwo">
                                    <Row className="nowrap-item padding-header-graph">
                                        <CardImg className='card-icons-species' src={secondGraph} alt="" />
                                        <Col className="card-header">Sample & Result Distribution on Floor</Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col className="dashboard-label-names">Region</Col>
                                        <Col className="graph-filters">
                                            <Input className="edit-input-values-dashboard" type="select" name="building" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                                <option value="" default>Region*</option>
                                                {this.props.buildingList.map((building, key) => {
                                                    return <option id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                        <Col className="graph-filters">
                                            <Input className="edit-input-values-dashboard" id="period" type="select" name="SamplesPeriod" value={this.state.SamplesPeriod} onChange={this.handleChangeSelect} size="1">
                                                <option value="" default>Period*</option>
                                                <option value="Weekly" >Weekly</option>
                                                <option value="Monthly">Monthly</option>
                                                <option value="Yearly">Yearly</option>
                                            </Input>
                                        </Col>
                                        <Col className="dash-clear-button">
                                            <button type='reset' onClick={this.clearSampleLocations} className="graph-button-1">Clear Filter</button>
                                        </Col>
                                    </Row>
                                    <ResponsiveContainer height={600} width="95%">
                                        <ComposedChart
                                            className="pieChart"
                                            width={400}
                                            height={600}
                                            isAnimationActive={true}
                                            data={this.props.dashboardData.locations_count && this.props.dashboardData.locations_count.length ? this.props.dashboardData.locations_count.slice(0, 10) : [{ location__description: '', Samples: 0, Results: 0, building: '', unit: '', floor: '', room: '' }]}
                                            margin={{
                                                top: 10,
                                                right: 10,
                                                left: 0,
                                                bottom: 5
                                            }}
                                        >
                                            isAnimationActive={true}
                                            <CartesianGrid strokeWidth={0.3} />
                                            <XAxis angle={0} textAnchor="start" interval={0} height={280} dataKey="location__description" scale="band" stroke="#003883" fontSize="10" offset={50} width={300} tick={false} />
                                            <YAxis axisLine={false} allowDecimals={false} stroke="#003883" fontSize="10" width={30} />
                                            <Tooltip content={this.customizedTooltipChartGraph} />
                                            <Bar dataKey="Samples" barSize={20} fill="#6E93BF" radius={[5, 5, 0, 0]} background={{ fill: '#ECF1F7', radius: [5, 5, 0, 0] }} >
                                                <LabelList dataKey='floor' position='top' tick={true} />
                                                <LabelList dataKey='room' position='bottom' offset={20} fill='#8E90C0' tick={true} />
                                                <LabelList dataKey='unit' position='bottom' angle={-45} offset={80} tick={true} />
                                            </Bar>
                                            <Line type="monotone" dataKey="Results" stroke="#EE7D11" />
                                        </ComposedChart>
                                    </ResponsiveContainer>
                                </Col>
                                {!localStorage.getItem("guest") ?
                                    <Col className={window.innerWidth > 1450 ? "bargraph-species" : "bargraph-small-species"} style={window.innerWidth > 1450 ? { marginRight: '0.5%' } : { marginRight: '0%' }} data-tut="reactour__graph">
                                        <Row className="nowrap-item padding-header-graph">
                                            <CardImg className='card-icons-species' src={firstGraph} alt="" />
                                            <Col className="card-header">Most Common Complex and Sequence Type</Col>
                                        </Row>
                                        <hr />
                                        <Row >
                                            <Col className="dashboard-label-names">cgMLST</Col>
                                            <Col className="graph-filters">
                                                <Input className="edit-input-values-dashboard" type="select" name="filterType" value={this.state.filterType} onChange={this.handleChangeSelect} size="1">
                                                    <option value="complex_type">Complex Type</option>
                                                    <option value="sequence_type">Sequence Type</option>
                                                </Input>
                                            </Col>
                                            <Col className="graph-filters">
                                                <Input className="edit-input-values-dashboard" id="period" type="select" name="CTPeriod" value={this.state.CTPeriod} onChange={this.handleChangeSelect} size="1">
                                                    <option value="" default>Period*</option>
                                                    <option value="Weekly">Weekly</option>
                                                    <option value="Monthly">Monthly</option>
                                                    <option value="Yearly">Yearly</option>
                                                </Input>
                                            </Col>
                                            <Col className="dash-clear-button">
                                                <button type='reset' onClick={this.clear_CT_ST_Locations} className="graph-button-1">Clear Filter</button>
                                            </Col>
                                        </Row>
                                        <ResponsiveContainer height={450} width="95%">
                                            <ComposedChart className="pieChart"
                                                layout="vertical"
                                                width={800}
                                                height={600}
                                                data={this.props.dashboardData.locations_data}
                                                margin={{
                                                    top: 5,
                                                    right: 5,
                                                    left: 0,
                                                    bottom: 5
                                                }}
                                                barCategoryGap="65%"
                                                dx={-20}
                                            >
                                                <CartesianGrid strokeWidth={0.2} />
                                                {/* <XAxis type="number" stroke="#003883" fontSize="10" height={80} stroke="#8E90C0" label={{ value: 'X-axis: Count of Occurence, Y axis: Strain Type', angle: 0,  position: 'insideBottomCenter', font: 'normal normal normal 7px/9px Montserrat', color: '#003883' }}/> */}
                                                <XAxis type="number" fontSize="10" height={80} stroke="#8E90C0" />
                                                <YAxis dataKey={this.state.filterType} type="category" scale="band" interval={0} stroke="#8E90C0" fontSize="10" color='#FFFFF' tickSize={0} width={35} dx={-9} />
                                                <Tooltip content={this.customizedTooltipVerticalGraph} />
                                                <Bar dataKey="Count" fill="#0CBCE3" radius={[0, 10, 10, 0]} background={{ fill: '#D9F4FA', radius: [0, 10, 10, 0] }} isAnimationActive={true} stackId="a">
                                                    <LabelList type="number" position="right" fill="#8E90C0" />
                                                </Bar>
                                            </ComposedChart>
                                        </ResponsiveContainer>
                                    </Col>
                                    : <Col className={window.innerWidth > 1450 ? "bargraph-species" : "bargraph-small-species"} style={window.innerWidth > 1450 ? { marginRight: '0.5%' } : { marginRight: '0%' }} data-tut="reactour__graph">
                                        <Row className="nowrap-item padding-header-graph">
                                            <CardImg className='card-icons-species' src={firstGraph} alt="" />
                                            <Col className="card-header">Abundance of Species over time</Col>
                                        </Row>
                                        <hr />
                                        <Row >
                                            <Col className="dashboard-label-names">Species</Col>
                                            <Col className="graph-filters dash-date-col">
                                                {this.state.CTPeriod === "Weekly" ? <DatePicker
                                                    className="sample-input-fields form-control dashboard-datetime"
                                                    onChange={(date) => this.onDateChange("speciesStartDate", "speciesEndDate", date)}
                                                    showWeekNumbers
                                                    weekLabel="Week"
                                                    maxDate={new Date()}
                                                    selected={this.state.speciesEndDate}
                                                    dayClassName={(date) => {
                                                        return this.state.speciesStartDate <= date && this.state.speciesEndDate >= date ? "dashDay" : undefined
                                                    }}
                                                    highlightDates={this.getWeek(this.state.highlightDates)}
                                                    onDayMouseEnter={(date) => {
                                                        let today = new Date(new Date().toDateString())
                                                        let firstDate = moment(date).subtract(moment(date).day(), 'days')
                                                        let presentWeek = moment(today).subtract(moment(today).day(), 'days')
                                                        this.setState({ highlightDates: new Date(presentWeek.diff(firstDate, 'days') > 0 ? firstDate : presentWeek.subtract(6 - moment(today).day(), 'days')) })
                                                    }}
                                                    onCalendarClose={() => this.setState({ highlightDates: "" })}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="Week*"
                                                    dateFormat="wo 'Week of' yyyy"
                                                /> : this.state.CTPeriod === "Monthly" ? <DatePicker
                                                    className="form-control sample-input-fields dashboard-datetime"
                                                    onChange={(date) => this.onMonthChange("speciesMonth", date)}
                                                    showMonthYearPicker
                                                    showFullMonthYearPicker
                                                    selected={this.state.speciesMonth}
                                                    maxDate={new Date()}
                                                    dateFormat="MMMM yyyy"
                                                    placeholderText="Month*"
                                                /> : this.state.CTPeriod === "Yearly" ? <DatePicker
                                                    className="form-control sample-input-fields dashboard-datetime"
                                                    onChange={(date) => this.onYearChange("speciesYear", date)}
                                                    showYearDropdown
                                                    showYearPicker
                                                    selected={this.state.speciesYear}
                                                    maxDate={new Date()}
                                                    dateFormat="yyyy"
                                                    placeholderText="Year*"
                                                /> : <DatePicker className="form-control sample-input-fields dashboard-datetime" placeholderText="Date*" disabled={true} />}
                                                {/* <DatePicker
                                    dateFormat="MM/yyyy"
                                    selected={this.state.toDate}
                                    onChange={this.toDateChange}
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    showTwoColumnMonthYearPicker
                                    minDate={this.state.yearAgo}
                                    maxDate={this.state.today}
                                    className="dashboard-datetime edit-input-values-dashboard form-control"
                                    autoComplete='off'
                                    placeholderText='To*'
                                    wrapperClassName="datepicker-wrapper"
                                    /> */}
                                                {/* <Input className="edit-input-values-dashboard"  id="period" type="select" name="toDate" value={this.state.toDate} onChange={this.handleChangeSelect} size="1">
                                    <option value="" default>To*</option>
                                    {this.getAllMonths().map((month) => {
                                        return <option className="sample-inputs" value={months.indexOf(month)} disabled={this.state.fromDate && this.getAllMonths().indexOf(month)<this.getAllMonths().indexOf(months[this.state.fromDate])}>{month}</option>
                                    })}
                                </Input> */}
                                            </Col>
                                            <Col className="graph-filters">
                                                {/* <DatePicker
                                    selected={this.state.fromDate}
                                    dateFormat="MM/yyyy"
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    showTwoColumnMonthYearPicker
                                    minDate={this.state.yearAgo}
                                    maxDate={this.state.today}
                                    onChange={this.fromDateChange}
                                    className="dashboard-datetime edit-input-values-dashboard form-control"
                                    autoComplete='off'
                                    placeholderText='From*'
                                    wrapperClassName="datepicker-wrapper"
                                    /> */}
                                                {/* <Input className="edit-input-values-dashboard"  id="period" type="select" name="fromDate" value={this.state.fromDate} onChange={this.handleChangeSelect} size="1">
                                    <option value="" default>From*</option>
                                    {this.getAllMonths().map((month) => {
                                        return <option className="sample-inputs" value={months.indexOf(month)} disabled={this.state.toDate && this.getAllMonths().indexOf(month)>this.getAllMonths().indexOf(months[this.state.toDate])}>{month}</option>
                                    })}
                                </Input> */}
                                                <Input className="edit-input-values-dashboard" id="period" type="select" name="CTPeriod" value={this.state.CTPeriod} onChange={this.handleChangeSelect} size="1">
                                                    <option value="" default>Period*</option>
                                                    <option value="Weekly">Weekly</option>
                                                    <option value="Monthly">Monthly</option>
                                                    <option value="Yearly">Yearly</option>
                                                </Input>
                                            </Col>
                                            <Col className="dash-clear-button">
                                                <button type='reset' onClick={this.clear_dates} className="graph-button-1">Clear Filter</button>
                                            </Col>
                                        </Row>
                                        <ResponsiveContainer height={450} width="95%">
                                            <LineChart className="pieChart"
                                                width={800}
                                                height={600}
                                                data={this.state.speciesData}
                                                margin={{
                                                    top: 5,
                                                    right: 5,
                                                    left: 0,
                                                    bottom: 5
                                                }}
                                                barCategoryGap="65%"
                                                dx={-20}
                                            >
                                                <CartesianGrid strokeWidth={0.2} />
                                                <XAxis type="category" fontSize="10" height={80} dataKey="name" stroke="#8E90C0" label={{ value: 'Time Period' }} />
                                                <YAxis type="number" fontSize="10" height={80} stroke="#003883" label={{ value: '% of DNA found', angle: -90, position: 'insideLeft' }} />
                                                <Tooltip />

                                                <Legend layout="horizontal" verticalAlign="top" align="right" />
                                                {this.state.speciesData.length > 0 &&
                                                    Object.keys(this.state.speciesData[0]).map((species, index) => {
                                                        if (index === 0)
                                                            return null;
                                                        return <Line dataKey={species} stroke={colors[index]} dot={true} strokeWidth={1.5} />
                                                    })
                                                }
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </Col>}
                                <Row className="recent-activity">
                                    <Row className={window.innerWidth > 900 ? "recent-activity-layout" : "recent-activity-layout-small"} data-tut="reactour__recent">
                                        <Row className="nowrap-item padding-header-graph">
                                            <CardImg className='card-icons-species' src={recentActivityIcon} alt="" />
                                            <Col className="card-header">Recent Activity</Col>
                                        </Row>
                                        <hr />
                                        <ResponsiveContainer>
                                            <div className="recent">
                                                {recent_activity !== undefined ? recent_activity.length > 0 ?

                                                    <div className="recent-table">
                                                        <ReactTable className="Data-Table"
                                                            style={{ overflow: 'visible' }}
                                                            data={recent_activity}
                                                            columns={this.columns}
                                                            showPagination={false}
                                                            minRows={0}
                                                            sortable={true}
                                                        />
                                                    </div>
                                                    :
                                                    null
                                                    : null
                                                }
                                            </div>
                                        </ResponsiveContainer>
                                    </Row>
                                </Row>
                            </Row>
                            :
                            <Row style={{ marginRight: '1%' }}>
                                <Col className="recent-activity-small">
                                    <Row className={window.innerWidth > 650 ? "bargraph-species" : "bargraph-small-species"} data-tut="reactour__recent">
                                        <Row className="nowrap-item padding-header-graph">
                                            <CardImg className='card-icons-species' src={recentActivityIcon} alt="" />
                                            <Col className="card-header">Recent Activity</Col>
                                        </Row>
                                        <hr />
                                        <ResponsiveContainer>
                                            <div className="recent">
                                                {recent_activity !== undefined ? recent_activity.length > 0 ?

                                                    <div className="recent-table">
                                                        <ReactTable className="Data-Table"
                                                            style={{ overflow: 'visible' }}
                                                            data={recent_activity}
                                                            columns={this.columns}
                                                            showPagination={false}
                                                            minRows={0}
                                                            sortable={true}
                                                        />
                                                    </div>
                                                    :
                                                    null
                                                    : null
                                                }
                                            </div>
                                        </ResponsiveContainer>
                                    </Row>
                                </Col>
                            </Row>}

                        {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                    </div>
                </div>
            </>
        )
    }
}


const mapStateToProps = state => {
    return {
        dashboardData: state.sample_data.dashboardData,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchSampleCount,
        fetchBuilding,
        fetchFloors,
    }
)(Dashboard), 'Dashboard', 'Dashboard');